import useCommonStore from 'hooks/useCommonStore';
import { SET_PROFILE_OCCUPATION } from 'store/action';

const useProfileStore = () => {
  const { state, setState, dispatch, setLoading } = useCommonStore();
  const { profileOccupation } = state || {};

  const setProfileOccupation = (payload = null) => {
    setState({
      action: SET_PROFILE_OCCUPATION,
      payload,
    });
  };

  return {
    ...state,
    state,
    setState,
    dispatch,
    setLoading,
    profileOccupation,
    setProfileOccupation,
  };
};

export default useProfileStore;
